<template>
  <div class="about">
    <h1>This is an about Miral Gondalia</h1>
  </div>
</template>
